import React from 'react';

import styled from '@emotion/styled';

import { TableDateSearchComponent } from '../../components/TableCom/TableDateSearchComponent';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CrmDetails from '../../sections/dashboard/crm/CrmDetails';

const Crm = () => {
  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <TableDateSearchComponent
            rigthRevealComponent={CrmDetails}
            tableBaseUrl="general-service/v1/packages"
            tableHeader={[
              'packageId',
              'customerName',
              'customerPhoneNumber',
              'specialFee',
              'paymentStatus',
              'deliveryCity',
              'createdAt',
              'status',
            ]}
            mappingData={{
              packageId: 'Product Id',
              customerName: 'Customer name',
              customerPhoneNumber: 'Phone',
              specialFee: 'Last mile price',
              paymentStatus: 'Payment status',
              deliveryCity: 'Area',
              createdAt: 'Date created',
              status: 'Status',
            }}
          />
        </Container>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default Crm;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
